import { Blue80, Button, Gray100, typeBase14RegularProperties } from '@traceair/tds';
import React from 'react';
import { stylesheet } from 'typestyle';
import { Customer, Site } from '../../../../../../types';
import { trackAction } from '../../../../../../libs/analytics/ActionTracking';
import { GcpIcon } from '../../../../../../images/components/GcpIcon';
import { useAppStore } from '../../../../../../store/appStore';
import { format, parseISO } from 'date-fns';

const css = stylesheet({
  button: {
    marginTop: 8,
  },
  lastModified: {
    marginTop: 8,
    color: Gray100,
    ...typeBase14RegularProperties,
  },
});

interface Props {
  customer: Customer;
  site: Site;
}

const formatLastModified = (lastModified: string) => {
  const date = parseISO(lastModified);
  const now = new Date();

  const isSameYear = date.getFullYear() === now.getFullYear();
  const dateFormat = isSameYear ? 'd MMMM' : 'd MMMM yyyy';

  return `Updated ${format(date, dateFormat)}`;
};

export const ExistingGcpsButton = ({ customer, site }: Props) => {
  const { getFlightMarkersLastModified, getGcpRequest } = useAppStore();

  const lastModified = getFlightMarkersLastModified(customer.id, site.id);
  const gcpRequest = getGcpRequest(customer.id, site.id);

  const handleClick = () => {
    trackAction('Click to "Existing GCP" button', { customer, site });
    window.open(GcpAppUrl + `/#/customers/${customer.id}/sites/${site.id}/pilot`);
  };

  return (
    <>
      <Button
        className={css.button}
        style="secondary"
        text="Existing GCPs"
        icon={<GcpIcon fill={Blue80} />}
        fullWidth
        size="xs"
        onClick={handleClick}
      />

      {gcpRequest !== undefined && lastModified && (
        <div className={css.lastModified}>{formatLastModified(lastModified)}</div>
      )}
    </>
  );
};
